
import axios from 'axios';
import React, { Component } from 'react';
import styled from 'styled-components';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import { DateTimeDisplay } from 'core/Display';
import { grey, red } from '@material-ui/core/colors';
import {Dialog, DialogActions, DialogContent, DialogContentText, Button} from "@material-ui/core";
import {FileLink} from "common/FileLink";

const StyledUploadedDocumentItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-gap: 10px;
  
  margin-bottom: 15px;
  
  .name {
    margin-bottom: 5px;
  }
  
  .user {
    color: ${grey[700]};
    font-size: 12px;
  }
  
  .sending {
    margin-top: 5px;
    font-size: 12px;
    color: ${grey[700]};
    
    span {
      color: ${grey[900]};
    }
  }
  
  .union {
    margin-top: 5px;
    font-size: 12px;
    color: ${red[900]};
  }
`;


export default class UploadedDocumentItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isOpen: false
    }
  }

  handleDelete = () => {
    const { item, context } = this.props;
    this.setState({
      loading: true
    });
    axios.delete(item.meta.url).then(res => {
      this.setState({
        loading: false,
        isOpen: false
      }, () => context.reload());
    })
  };

  toggleDialog = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render() {
    const { item, order, onClick } = this.props;
    const { loading, isOpen } = this.state;
    return (
      <StyledUploadedDocumentItem>
        <div>
          <div className={'name'}>
            <FileLink
              fileUrl={item.file}
              fileName={item.file_name}
              fileContentType={item.file_content_type}
              onClick={onClick}
            />
          </div>
          <div>
          </div>
          <div className={'user'}>
            <span>{item.user.short_name || item.user.username}</span>
            <span className={'ml-10'}><DateTimeDisplay value={item.created} /></span>
            {item.description && <span className={'ml-10'}>{item.description}</span>}
          </div>
          {item.sending_by_user && (
            <div className={'sending'}>
              Отправлены <span><DateTimeDisplay value={item.sending_date} /></span>
              {' '}пользователем <span>{item.sending_by_user.short_name || item.sending_by_user.username}</span>
            </div>
          )}
          {item.order !== order.id && (
            <div className={'union'}>
              <span>Объединённый бухгалтерский документ из перевозки № {item.order}</span>
            </div>
          )}
        </div>
        <div>
          <IconButton size="small" disabled={loading} onClick={() => this.toggleDialog()}>
            <ClearIcon />
          </IconButton>
        </div>
        <Dialog
          open={isOpen}
        >
          <DialogContent>
            <DialogContentText>
              Вы уверены, что хотите удалить файл?<br/>
              <a href={item.file} target={'_blank'} rel="noopener noreferrer">
                {item.file_name}
              </a>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} autoFocus onClick={() => this.toggleDialog()}>
              Отмена
            </Button>
            <Button disabled={loading} onClick={() => this.handleDelete()}>
              Да
            </Button>
          </DialogActions>
        </Dialog>
      </StyledUploadedDocumentItem>
    )
  }
}
